import React from "react";
import { useRouter } from "next/router";
import { parse } from "qs";

import { STRAIN_USER_REVIEW_DISCLAIMER } from "constants/disclaimers";
import { MenuItemCard } from "custom-types/MenuItemCard";
import parseNextRouterAsPath from "utils/parseNextRouterAsPath";
import slugifyName from "utils/slugifyName";

import SimilarEffectsIcon from "components/Icons/similar-effects.svg";
import TooltipCTA from "components/StrainPage/TooltipCTA";

const MenuItemResultsStrainEffectCopy = ({
  isPickup,
  menuItems,
}: {
  isPickup: boolean;
  menuItems: MenuItemCard[];
}) => {
  const { asPath } = useRouter();
  const { query: parsedQuery } = parseNextRouterAsPath(asPath);
  const { boost_options, filter } = parsedQuery;
  const boostStrain = parse(boost_options as string)?.strain_name;
  const topStrainEffectsIncluded = parse(
    filter as string,
  ).top_strain_effects_included;

  if (!topStrainEffectsIncluded || !boostStrain) {
    if (isPickup) {
      return (
        <h3 className="hidden md:block pb-lg">
          Try ordering for in-store pickup.
        </h3>
      );
    } else {
      return <></>;
    }
  }

  const boostStrainSlug = boostStrain ? slugifyName(boostStrain as string) : "";

  const hasStrainMatchedProducts = menuItems.find(
    (item: MenuItemCard) => item.strain?.slug === boostStrainSlug,
  );

  const header = hasStrainMatchedProducts
    ? `Shop ${boostStrain} and products with similar effects`
    : `${boostStrain} not available but we found these similar products`;

  return (
    <div className="p-xs" data-testid="strain-effect-copy">
      <h3 data-testid="strain-effect-header">{header}</h3>
      <div className="my-md">
        <TooltipCTA
          title="Similar strains have similar effects"
          icon={<SimilarEffectsIcon width="25" height="25" />}
          sectionName="similar-strains"
          maxWidth="∞" // No max width
          className="px-lg"
        >
          <>
            <p>{STRAIN_USER_REVIEW_DISCLAIMER}</p>
          </>
        </TooltipCTA>
      </div>
    </div>
  );
};

export default MenuItemResultsStrainEffectCopy;
